import { Badge, Button, CircularProgress, Menu, Paper, Popover, Chip, TextField } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useContext, useEffect, useState } from 'react';
import { createOrderPDFReport, getOrderPDFReportHTML, submitOrder as submitFieldRepOrder } from '../../services';
import { HoldOrderButton } from '../HoldOrderButton';
import { ReportFees } from '../ReportFees';
import { ReturnOrderButton } from '../ReturnOrderButton';
import { OrderReviewContext, getNextVisibleFormHeaderIndex } from './OrderReviewContext';
import { PostRCTAnswers, getBetterViewProperty } from '../../services';
import { isStupidICatOrCIGOrder } from '../../helpers';
import { ReportSupplementForms } from '../ReportSupplementForms';
import QAReturnToMobileAppButton from '../QAReturnToMobileAppButton/QAReturnToMobileAppButton';
import { useHistory } from 'react-router';
import { AppContext } from '../../AppContext';
import { ConfirmationDialog } from '../ConfirmationDialog';
import AttachmentsMenuButton from './ActionBar/Attachments/AttachmentsMenuButton';
import { CancelOrderButton } from '../CancelOrderButton/CancelOrderButton';
import { releaseOrder as releaseCallCenterOrder } from '../../services/callcenter.service';

const propTypes = {
  classes: PropTypes.object.isRequired,
  submitReport: PropTypes.func.isRequired,
  setIsCompleteDialogOpen: PropTypes.func.isRequired,
  setPdfPreviewLink: PropTypes.func.isRequired,
  isCancelled: PropTypes.bool,
  isRejectRestricted: PropTypes.bool,
  order: PropTypes.object,
  setOrder: PropTypes.func,
  setIsRCTCompleteDialogOpen: PropTypes.func.isRequired,
  isAllPhotosTab: PropTypes.bool,
};

const BUTTON_GROUPS = {
  ORDER_MANAGEMENT: 'ORDER_MANAGEMENT',
  ATTACHMENTS: 'ATTACHMENTS',
  FEES: 'FEES',
  SUPPLEMENTS: 'SUPPLEMENTS',
};

const PureActionBar = ({
  classes,
  submitReport,
  setIsCompleteDialogOpen,
  setPdfPreviewLink,
  isCancelled,
  isRejectRestricted,
  order,
  setOrder,
  setIsRCTCompleteDialogOpen,
  isAllPhotosTab,
}) => {
  const { dispatch: appDispatch } = useContext(AppContext);
  const { state, dispatch } = useContext(OrderReviewContext);
  const [isFirstFormHeader, setIsFirstFormHeader] = useState(true);
  const [isLastFormHeader, setIsLastFormHeader] = useState(false);
  const [isLoadingPreviewLink, setIsLoadingPreviewLink] = useState(false);
  const [isBetterviewRefreshing, setIsBetterviewRefreshing] = useState(false);
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const [activeButtonGroupName, setActiveButtonGroupName] = useState(null);
  const [showFieldRepSubmitOrderConfirmationDialog, setShowFieldRepSubmitOrderConfirmationDialog] = useState(false);
  const [showCallCenterReleaseOrderConfirmationDialog, setShowCallCenterReleaseOrderConfirmationDialog] = useState(false);
  const [showIQFollowUpDialog, setShowIQFollowUpDialog] = useState(false);
  const [iqPhoneNumber, setIqPhoneNumber] = useState('');
  
  const [isSubmittingFieldRepReport, setIsSubmittingFieldRepReport] = useState(false);
  const [isSubmittingCallCenterReport, setIsSubmittingCallCenterReport] = useState(false);

  const history = useHistory();

  const menuOpen = !!menuAnchorEl;

  useEffect(() => {
    firstFormHeaderCheck();
    lastFormHeaderCheck();
  }, [state.formHeaders[state.activeFormHeaderIndex]]);

  const lastFormHeaderCheck = () => {
    // if it's not cancelled, then the last index is the number of form headers - 1
    // otherwise, the index is the length of form headers (since it is an extra tab and arrays are 0-indexed)
    // hidden form headers (e.g. underwriting action for non-admins) don't count as a next step
    const isLast = getNextVisibleFormHeaderIndex(state, state.activeFormHeaderIndex, 1) === -1;
    setIsLastFormHeader(isLast);
  };

  const firstFormHeaderCheck = () => {
    setIsFirstFormHeader(getNextVisibleFormHeaderIndex(state, state.activeFormHeaderIndex, -1) === -1);
  };

  const getOrderPDFReportHTMLAsync = () => {
    getOrderPDFReportHTML(state.orderLineId)
      .then(data => {
        submitReport();
        setIsCompleteDialogOpen(true);
      })
      .catch(error => console.log(error));
  };

  const handleComplete = event => {
    console.log({state});
    console.log(state.formHeaders[state.activeFormHeaderIndex].formHeaderId)
    if (state.isRCT) {
      event.preventDefault();

      var formKeyValues = event.nativeEvent.currentTarget.all;
      var orderLineID = state.orderLineId;

      const fields = Array.prototype.slice
        .call(formKeyValues)
        .filter(el => el.name)
        .reduce(
          (form, el) => ({
            ...form,
            [el.name]: el.value,
          }),
          {},
        );

      var arFormFields = {};

      var tifOptions = Object.keys(fields).forEach(function(key) {
        if (fields[key] != undefined) {
          var test = 0;
          var keyParts = key.split('_');
          var cntrlType = keyParts[2];

          var test = keyParts[1];

          if (cntrlType == 'checkbox') {
            var cntrl = document.getElementsByName(key)[0];
            if (cntrl.checked) {
              arFormFields[key] = fields[key];
            }
          } else if (cntrlType == 'radio') {
            var radios = document.getElementsByName(key);

            for (var i = 0, length = radios.length; i < length; i++) {
              if (radios[i].checked) {
                var ctrlID = radios[i].value;
                arFormFields[key] = ctrlID;

                // only one radio can be logically checked, don't check the rest
                break;
              }
            }
          } else {
            arFormFields[key] = fields[key];
          }
        }
      });

      var fieldsSaved = JSON.stringify(arFormFields);

      PostRCTAnswers(fieldsSaved, orderLineID);

      setIsLastFormHeader(true);
    } else {
      if (isLastFormHeader) {
        getOrderPDFReportHTMLAsync();
      } else {
        const nextFormHeaderIndex = getNextVisibleFormHeaderIndex(state, state.activeFormHeaderIndex, 1);
        dispatch({
          type: 'CHANGE_FORM_HEADER',
          FormHeaderIndex: nextFormHeaderIndex,
        });
      }
    }
  };

  const getPdfPreview = async () => {
    setIsLoadingPreviewLink(true);
    try {
      const link = await createOrderPDFReport(state.orderLineId, state.isValuationOverride);
      setIsCompleteDialogOpen(true);
      setPdfPreviewLink(link);
    } catch (err) {
      const isReplacementCostError = err.includes("Error converting data type varchar to float");
      const isInvalidDateFormatError = err.includes("Invalid date format");
      appDispatch({
        type: 'SET_SNACKBAR',
        snackbar: {
          isOpen: true,
          variant: 'error',
          message: isReplacementCostError 
            ? 'Please check the Replacement Cost field to make sure it is a number.' 
            : isInvalidDateFormatError
              ? err
              : err,
        },
      });
      console.log(err);
    }
    setIsLoadingPreviewLink(false);
  };

  const submitFieldRepReport = async () => {
    setIsSubmittingFieldRepReport(true);
    try {
      await submitFieldRepOrder(state.orderLineId);

      appDispatch({
        type: 'SET_SNACKBAR',
        snackbar: {
          isOpen: true,
          variant: 'success',
          message: 'Order submitted successfully!',
        },
      });
      history.push('/');
    } catch (err) {
      console.log(err);
      appDispatch({
        type: 'SET_SNACKBAR',
        snackbar: {
          isOpen: true,
          variant: 'error',
          message: err.message || 'There was an error submitting the order...',
        },
      });
    }
    setIsSubmittingFieldRepReport(false);
  };
  // IQ follow-up: commercial (propertyTypeId 2) + IQ from orderLineDetail[].product (API uses iqproduct)
  const orderLineDetails = Array.isArray(order?.orderLineDetail) ? order.orderLineDetail : [];
  const hasCommercialIqFromLineDetails = orderLineDetails.some(detail => {
    const p = detail?.product;
    if (!p) return false;
    const iq = p.iqProduct ?? p.iqproduct ?? p.isIqProduct;
    return Boolean(iq) && Number(p.propertyTypeId) === 2;
  });
  const iqProductFallback =
    order?.iqProduct || order?.product?.iqProduct || order?.isIqProduct || order?.product?.isIqProduct;
  const propertyTypeIdFallback = order?.propertyTypeId ?? order?.product?.propertyTypeId;
  const isIQProductWithPropertyType2 =
    hasCommercialIqFromLineDetails ||
    (Boolean(iqProductFallback) && Number(propertyTypeIdFallback) === 2);

  const handleInterviewYesClick = () => {
    setShowCallCenterReleaseOrderConfirmationDialog(false);
    
    // If IQ product with propertyTypeId 2, show the IQ follow-up dialog
    if (isIQProductWithPropertyType2) {
      setShowIQFollowUpDialog(true);
    } else {
      // Otherwise, submit directly with interview confirmed
      submitCallCenterReport(true, false, null);
    }
  };

  const handleIQFollowUpSubmit = (participatesInIQ) => {
    // Don't close the dialog - let it show the loading state
    // Dialog will close on successful navigation or we'll keep it open on error
    submitCallCenterReport(true, participatesInIQ, participatesInIQ ? iqPhoneNumber : null, true);
  };

  const submitCallCenterReport = async (interviewConducted, participatesInIQ = null, iqPhone = null, fromIQDialog = false) => {
    setIsSubmittingCallCenterReport(true);
    try {
      await releaseCallCenterOrder(state.orderLineId, interviewConducted, participatesInIQ, iqPhone);

      appDispatch({
        type: 'SET_SNACKBAR',
        snackbar: {
          isOpen: true,
          variant: 'success',
          message: 'Order submitted successfully!',
        },
      });
      
      // Clean up state before navigation
      if (fromIQDialog) {
        setShowIQFollowUpDialog(false);
        setIqPhoneNumber('');
      }
      
      history.push('/');
    } catch (err) {
      console.log(err);
      appDispatch({
        type: 'SET_SNACKBAR',
        snackbar: {
          isOpen: true,
          variant: 'error',
          message: err.message || 'There was an error submitting the order...',
        },
      });
      // On error, close the IQ dialog so user can try again
      if (fromIQDialog) {
        setShowIQFollowUpDialog(false);
        setIqPhoneNumber('');
      }
    }
    setIsSubmittingCallCenterReport(false);
  };
  
  const getRCTPdfPreview = async () => {
    setIsLoadingPreviewLink(true);
    try {
      const link = await createOrderPDFReport(state.orderLineId, state.isValuationOverride);
      setIsRCTCompleteDialogOpen(true);
      setPdfPreviewLink(link);
    } catch (err) {
      console.log(err);
    }
    setIsLoadingPreviewLink(false);
  };

  const submitRCTInspection = async () => {
    try {
      if (isStupidICatOrCIGOrder(state.clientId)) {
        setIsRCTCompleteDialogOpen(true);
      } else {
        getRCTPdfPreview();
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handlePrevious = () => {
    const prevFormHeaderIndex = getNextVisibleFormHeaderIndex(state, state.activeFormHeaderIndex, -1);
    if (prevFormHeaderIndex === -1) return;
    dispatch({
      type: 'CHANGE_FORM_HEADER',
      FormHeaderIndex: prevFormHeaderIndex,
    });
  };

  const handleBetterviewRefresh = async () => {
    setIsBetterviewRefreshing(true);
    const betterviewResponse = await getBetterViewProperty(state.orderLineId);
    if (betterviewResponse) {
      setIsBetterviewRefreshing(false);
    }
  };

  const handleOpenMenu = buttonGroupName => evt => {
    setActiveButtonGroupName(buttonGroupName);
    setMenuAnchorEl(evt.currentTarget);
  };

  const handleCloseMenu = () => {
    setMenuAnchorEl(null);
  };

  const renderActiveButtonGroup = () => {
    switch (activeButtonGroupName) {
      case BUTTON_GROUPS.ORDER_MANAGEMENT: {
        return (
          <>
            {!isCancelled && !state.isFieldRep && (!isRejectRestricted || state.isAdmin ) && (
              <ReturnOrderButton
                //
                orderLineId={state.orderLineId}
                onClose={handleCloseMenu}
              />
            )}
            {!isCancelled && !state.isFieldRep && (
              <HoldOrderButton
                //
                orderLineId={state.orderLineId}
                onClose={handleCloseMenu}
              />
            )}
            {!isCancelled && !state.isFieldRep && <CancelOrderButton orderLineId={state.orderLineId} />}

            {state.isFieldRep && <QAReturnToMobileAppButton onClose={handleCloseMenu} />}
          </>
        );
      }

      case BUTTON_GROUPS.ATTACHMENTS: {
        return (
          <>
            {/* <ReportAttachments orderLineId={state.orderLineId} onClose={handleCloseMenu} />

            {!state.isClient && !state.isUnderwriter && (
              <QAPhotoUploadDialog
                orderLineId={state.orderLineId}
                order={order}
                setOrder={setOrder}
                onClose={handleCloseMenu}
              />
            )}

            {!state.isClient && !state.isUnderwriter && <QAPhotoDownload onClose={handleCloseMenu} />} */}
          </>
        );
      }

      case BUTTON_GROUPS.FEES: {
        return (
          <>
            {!state.isClient && !state.isUnderwriter && !state.isFieldRep && (
              <ReportFees order={order} setOrder={setOrder} onClose={handleCloseMenu} />
            )}
          </>
        );
      }

      case BUTTON_GROUPS.SUPPLEMENTS: {
        console.log(state.formHeaders[state.activeFormHeaderIndex].formHeaderId);
        return (
          <>
            {!state.isClient && !state.isUnderwriter && (
              <ReportSupplementForms
                orderLineId={state.orderLineId}
                order={order}
                setOrder={setOrder}
                onClose={handleCloseMenu}
              />
            )}
          </>
        );
      }

      default:
        return null;
    }
  };

  return (
    <Paper elevation={1} className={classes.actionBarWrapper}>
      <div>
        {(state.isFieldRep || !isCancelled) && (
          <Button
            onClick={handleOpenMenu(BUTTON_GROUPS.ORDER_MANAGEMENT)}
            variant="contained"
            className={classNames(classes.buttonDropdownButton, classes.orderManagementButton)}
            endIcon={<KeyboardArrowUpIcon />}
          >
            Order
          </Button>
        )}

        <AttachmentsMenuButton
          //
          classes={classes}
          order={order}
          setOrder={setOrder}
        />

        {!state.isFieldRep && (
          <Button
            onClick={handleOpenMenu(BUTTON_GROUPS.FEES)}
            variant="contained"
            className={classNames(classes.buttonDropdownButton, classes.feesButton)}
            endIcon={<KeyboardArrowUpIcon />}
          >
            Fees
          </Button>
        )}

        <Button
          onClick={handleOpenMenu(BUTTON_GROUPS.SUPPLEMENTS)}
          variant="contained"
          className={classNames(classes.buttonDropdownButton, classes.supplementsButton)}
          endIcon={<KeyboardArrowUpIcon />}
        >
          Forms
        </Button>

        {!state.isClient &&
          !state.isUnderwriter &&
          state.formHeaders[state.activeFormHeaderIndex].formHeaderId === 1117 && (
            <Button
              variant="contained"
              disabled={isBetterviewRefreshing}
              onClick={handleBetterviewRefresh}
              className={classNames(!isBetterviewRefreshing && 'light-blue-background')}
              style={{ marginRight: 10 }}
            >
              {isBetterviewRefreshing ? 'Refreshing Betterview' : 'Refresh Betterview'}
            </Button>
          )}

        <Popover
          transformOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          anchorEl={menuAnchorEl}
          open={menuOpen}
          onClose={handleCloseMenu}
        >
          {renderActiveButtonGroup()}
        </Popover>
      </div>

      {/* <div className={classNames('row-center-center')}>
        <div className={classNames('mx-5')}>
          <ReportAttachments orderLineId={state.orderLineId} />
        </div>

        {!state.isClient && !state.isUnderwriter && !state.isFieldRep && (
          <div className={classNames('mx-5')}>
            <ReportFees order={order} setOrder={setOrder} />
          </div>
        )}

        {!state.isClient && !state.isUnderwriter && (
          <div className={classNames('mx-5')}>
            <ReportSupplementForms orderLineId={state.orderLineId} order={order} setOrder={setOrder} />
          </div>
        )}

        {!state.isClient && !state.isUnderwriter && (
          <div className={classNames('mx-5')}>
            <QAPhotoUploadDialog orderLineId={state.orderLineId} order={order} setOrder={setOrder} />
          </div>
        )}

        {!state.isClient && !state.isUnderwriter && (
          <div className={classNames('mx-5')}>
            <QAPhotoDownload />
          </div>
        )}

        {state.isFieldRep && (
          <div className={classNames('mx-5')}>
            <QAReturnToMobileAppButton />
          </div>
        )}

        {!state.isClient &&
          !state.isUnderwriter &&
          state.formHeaders[state.activeFormHeaderIndex].formHeaderId === 1117 && (
            <div className={classNames('mx-5')}>
              <Button
                variant="contained"
                disabled={isBetterviewRefreshing}
                onClick={handleBetterviewRefresh}
                className={classNames(!isBetterviewRefreshing && 'light-blue-background')}
                style={{ marginRight: 10 }}
              >
                {isBetterviewRefreshing ? 'Refreshing Betterview' : 'Refresh Betterview'}
              </Button>
            </div>
          )}
      </div> */}
      <div>
        <Button
          variant="contained"
          disabled={isFirstFormHeader}
          onClick={handlePrevious}
          className={classNames(!isFirstFormHeader && 'light-blue-background')}
          style={{ marginRight: 10, marginLeft: 15 }}
        >
          Previous Step
        </Button>
        {!isLastFormHeader && (
          <Button
            variant="contained"
            color="primary"
            onClick={handleComplete}
            className={classNames('light-blue-background')}
          >
            Continue
          </Button>
        )}

        <ConfirmationDialog
          //
          visible={showFieldRepSubmitOrderConfirmationDialog}
          isSubmitting={isSubmittingFieldRepReport}
          minWidth={10}
          minHeight={10}
          title="Are you sure you want to submit the report?"
          cancelButton={
            <Button
              variant="contained"
              onClick={() => setShowFieldRepSubmitOrderConfirmationDialog(false)}
              className={classNames('light-blue-background')}
              disabled={isSubmittingFieldRepReport}
            >
              Cancel
            </Button>
          }
          acceptButton={
            <Button
              variant="contained"
              onClick={submitFieldRepReport}
              className={classNames('light-blue-background')}
              disabled={isSubmittingFieldRepReport}
            >
              Submit
            </Button>
          }
        />
<ConfirmationDialog
          //
          visible={showCallCenterReleaseOrderConfirmationDialog}
          isSubmitting={isSubmittingCallCenterReport}
          minWidth={10}
          minHeight={10}
          title="Are you sure you would like to release this order?  Please indicate whether you have conducted a phone interview to proceed."
          cancelButton={
            <Button
              variant="contained"
              onClick={() => setShowCallCenterReleaseOrderConfirmationDialog(false)}
              className={classNames('light-blue-background')}
              disabled={isSubmittingCallCenterReport}
            >
              Cancel
            </Button>
          }
          rejectButton={
            <Button
              variant="contained"
              onClick={() => submitCallCenterReport(false)}
              className={classNames('light-blue-background')}
              disabled={isSubmittingCallCenterReport}
            >
              No
            </Button>
          }
          acceptButton={
            <Button
              variant="contained"
              onClick={handleInterviewYesClick}
              className={classNames('light-blue-background')}
              disabled={isSubmittingCallCenterReport}
            >
              Yes
            </Button>
          }
        />
        <ConfirmationDialog
          //
          visible={showIQFollowUpDialog}
          isSubmitting={isSubmittingCallCenterReport}
          submitMessage={isSubmittingCallCenterReport ? "Releasing order..." : null}
          minWidth={400}
          minHeight={10}
          title="Invision IQ Participation"
          cancelButton={
            <Button
              variant="contained"
              onClick={() => {
                setShowIQFollowUpDialog(false);
                setIqPhoneNumber('');
              }}
              className={classNames('light-blue-background')}
              disabled={isSubmittingCallCenterReport}
            >
              Cancel
            </Button>
          }
          rejectButton={
            <Button
              variant="contained"
              onClick={() => handleIQFollowUpSubmit(false)}
              className={classNames('light-blue-background')}
              disabled={isSubmittingCallCenterReport}
            >
              {isSubmittingCallCenterReport ? <CircularProgress size={20} style={{ color: '#fff' }} /> : 'No'}
            </Button>
          }
          acceptButton={
            <Button
              variant="contained"
              onClick={() => handleIQFollowUpSubmit(true)}
              className={classNames('light-blue-background')}
              disabled={isSubmittingCallCenterReport || !iqPhoneNumber.trim()}
            >
              {isSubmittingCallCenterReport ? <CircularProgress size={20} style={{ color: '#fff' }} /> : 'Yes'}
            </Button>
          }
        >
          <div style={{ padding: '10px 0' }}>
            {isSubmittingCallCenterReport ? (
              <div style={{ textAlign: 'center', padding: '20px' }}>
                <CircularProgress />
                <p style={{ marginTop: '15px', color: '#666' }}>Releasing order, please wait...</p>
              </div>
            ) : (
              <>
                <p style={{ marginBottom: '20px' }}>
                  Will the insured be participating in the Invision IQ process?
                </p>
                <TextField
                  label="Phone Number"
                  variant="outlined"
                  fullWidth
                  value={iqPhoneNumber}
                  onChange={(e) => setIqPhoneNumber(e.target.value)}
                  placeholder="Enter phone number for IQ process"
                  helperText="Required if participating in IQ process"
                />
              </>
            )}
          </div>
        </ConfirmationDialog>
        {isLastFormHeader && !isCancelled && !state.isRCT && (
          <Button
            disabled={isLoadingPreviewLink || state.isAutoSaving || (!state.isValuationComplete && !state.isFieldRep)}
            variant="contained"
            onClick={state.isFieldRep ? () => setShowFieldRepSubmitOrderConfirmationDialog(true) : state.isCallCenter ? () => setShowCallCenterReleaseOrderConfirmationDialog(true) : getPdfPreview}
            className={classNames(
              !isLoadingPreviewLink &&
                !state.isAutoSaving &&
                (state.isValuationComplete || state.isFieldRep) &&
                'light-blue-background',
            )}
          >
            {isLoadingPreviewLink ? (
              <div className="row-center-center">
                Getting preview...
                <CircularProgress color="#fff" size={18} style={{ marginLeft: 10 }} />
              </div>
            ) : state.isAutoSaving ? (
              <div>
                Saving changes... <CircularProgress color="#fff" size={18} />
              </div>
            ) : !state.isValuationComplete && !state.isFieldRep ? (
              'Please Calculate Valuation'
            ) : (
              <>{state.isFieldRep ? 'Submit Report' : state.isCallCenter ? 'Release Order' : 'Generate Report Preview'}</>
            )}
          </Button>
        )}

        {isLastFormHeader && !isCancelled && state.isRCT && (
          <Button
            disabled={isLoadingPreviewLink || state.isAutoSaving || !state.isValuationComplete}
            variant="contained"
            onClick={submitRCTInspection}
            className={classNames(
              !isLoadingPreviewLink && !state.isAutoSaving && state.isValuationComplete && 'light-blue-background',
            )}
          >
            {isLoadingPreviewLink ? (
              <div>
                Getting preview... <CircularProgress color="#fff" size={18} />
              </div>
            ) : state.isAutoSaving ? (
              <div>
                Saving changes... <CircularProgress color="#fff" size={18} />
              </div>
            ) : !state.isValuationComplete && !state.isFieldRep ? (
              'Please Calculate Valuation'
            ) : (
              'Submit RCT Inspection'
            )}
          </Button>
        )}
      </div>
    </Paper>
  );
};

const styles = theme => ({
  actionBarWrapper: {
    padding: theme.spacing(2),
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    borderRadius: 0,
    zIndex: 1,
    margin: '0 -0.75rem -0.75rem -0.75rem',
  },
  prevButton: {
    backgroundColor: '#dedede',
    color: '6f6f6f',
    marginRight: '8px',
  },
  completeButton: {
    color: '#fff',
    backgroundColor: '#71BF47',
    '&:hover': {
      background: '#4f8a30',
    },
  },
  showAllButton: {
    marginLeft: '8px',
  },

  buttonDropdownButton: {
    marginRight: '8px',
    color: '#fff',
  },

  orderManagementButton: {
    backgroundColor: '#f44336',
    '&:hover': {
      background: '#d2190b',
    },
  },

  attachmentsButton: {
    backgroundColor: 'var(--jmi-blue)',
    '&:hover': {
      background: 'var(--jmi-blue-hover)',
    },
  },
  feesButton: {
    backgroundColor: 'var(--jmi-blue)',
    '&:hover': {
      background: 'var(--jmi-blue-hover)',
    },
  },
  supplementsButton: {
    backgroundColor: 'var(--jmi-blue)',
    '&:hover': {
      background: 'var(--jmi-blue-hover)',
    },
  },
});

PureActionBar.propTypes = propTypes;
export const ActionBar = withStyles(styles)(PureActionBar);
